import { TeamMemberEditRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/team/members/$userId/edit')({
  component: TeamMemberEditRoute,
});
